module.exports = __webpack_public_path__ + "img/b1-slide.23a28ad4.webp";